import { combineEpics } from 'redux-observable';
import { catchError } from 'rxjs/operators';
import userEpic, { UserEpicActions } from './user/epic';
import roomEpic, { RoomEpicActions } from './room/epic';
import loginEpic, { LoginEpicActions } from './login/epic';
import switchEpic, { SwitchEpicActions } from 'page/Switch/model/epic';
import meetingEpic, { MeetingEpicActions } from './meeting/epic';
import contactEpic, { ContactEpicActions } from './contact/epic';
import approvalEpic, { ApprovalEpicActions } from './approval/epic';

import { AppEpic } from './index';

const rootEpic: AppEpic<any> = (action$, store$, dependencies) =>
  combineEpics(
    userEpic,
    roomEpic,
    loginEpic,
    switchEpic,
    meetingEpic,
    contactEpic,
    approvalEpic
  )(action$, store$, dependencies).pipe(
    catchError((error, caught) => {
      console.error('rootEpic: ', error);
      return caught;
    })
  );
export default rootEpic;

export type RootEpicActions =
  | UserEpicActions
  | LoginEpicActions
  | SwitchEpicActions
  | RoomEpicActions
  | MeetingEpicActions
  | ContactEpicActions
  | ApprovalEpicActions;
